import { render, staticRenderFns } from "./SubTotalErrorFormatter.vue?vue&type=template&id=6cf190aa&functional=true"
import script from "./SubTotalErrorFormatter.vue?vue&type=script&lang=js"
export * from "./SubTotalErrorFormatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports